import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Messaging from './Messaging';
import NotificationCenter from './NotificationCenter';
import PageHeader from '../components/PageHeader';
import './Communication.css';

// Phase 6 hub — combines Messaging (SMS conversations) and Notifications
// (rule-driven outbound) under a single "Communication" surface with tabs.
// Route: /practice-view/communication?tab=messaging|notifications

const TABS = [
  { key: 'messaging', label: 'Messaging', description: 'Two-way SMS conversations with patients.' },
  { key: 'notifications', label: 'Notifications', description: 'Automated outbound rules for reminders, follow-ups, and campaigns.' },
];

function Communication({ practiceId }) {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const requestedTab = params.get('tab');
  const [tab, setTab] = useState(TABS.some(t => t.key === requestedTab) ? requestedTab : 'messaging');

  useEffect(() => {
    // Keep URL in sync so deep-links (from CommandPalette, etc.) land on the right tab
    const current = params.get('tab');
    if (current !== tab) {
      params.set('tab', tab);
      navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  const activeTab = TABS.find(t => t.key === tab) || TABS[0];

  return (
    <div className="communication">
      <PageHeader
        title="Communication"
        description={activeTab.description}
      />
      <div className="communication__tabs" role="tablist">
        {TABS.map(t => (
          <button
            key={t.key}
            role="tab"
            aria-selected={t.key === tab}
            className={`communication__tab ${t.key === tab ? 'communication__tab--active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="communication__body">
        {tab === 'messaging' && <Messaging practiceId={practiceId} embedded />}
        {tab === 'notifications' && <NotificationCenter practiceId={practiceId} embedded />}
      </div>
    </div>
  );
}

export default Communication;
